import { pageSelectors, usePage } from 'client/store/index'
import React from 'react'
import { FaqInterface } from 'src/shared/entities/faq/faq.schema'
import FaqSettings from './FaqSettings'

type FaqItemSettingsProps = {
  entity: FaqInterface
  defaultEntity?: FaqInterface
}

function FaqItemSettings({ entity, defaultEntity }: FaqItemSettingsProps) {
  const faqEntity = usePage(page =>
    pageSelectors.getEntityById(page, entity.parentId),
  ) as FaqInterface

  return <FaqSettings entity={faqEntity} defaultEntity={defaultEntity} />
}

export default FaqItemSettings
